import { useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useBooking } from '../../context/BookingContext'
import StepIndicator   from '../../components/booking/StepIndicator'
import SelectServices  from '../../components/booking/SelectServices'
import SelectStaff     from '../../components/booking/SelectStaff'
import SelectDateTime  from '../../components/booking/SelectDateTime'
import CustomerDetails from '../../components/booking/CustomerDetails'
import PaymentStep     from '../../components/booking/PaymentStep'
import BookingSummaryBar from '../../components/booking/BookingSummaryBar'
import { Helmet } from 'react-helmet-async'

const STEPS = [
  { id: 1, label: 'Services'  },
  { id: 2, label: 'Stylist'   },
  { id: 3, label: 'Date/Time' },
  { id: 4, label: 'Details'   },
  { id: 5, label: 'Payment'   },
]

export default function BookingPage() {
  const { user }     = useAuth()
  const { booking, setCustomer, reset } = useBooking()

  // Pre-fill customer details if logged in
  useEffect(() => {
    if (user) {
      setCustomer({ name: user.name, email: user.email, phone: user.phone || '' })
    }
    return () => { /* keep state on unmount */ }
  }, [user])

  const StepContent = () => {
    switch (booking.step) {
      case 1: return <SelectServices />
      case 2: return <SelectStaff />
      case 3: return <SelectDateTime />
      case 4: return <CustomerDetails />
      case 5: return <PaymentStep />
      default: return <SelectServices />
    }
  }

  return (
    <>
      <Helmet>
        <title>Book Appointment – Salon Vora</title>
      </Helmet>

      <div className="min-h-screen bg-salon-cream pt-20">
        {/* Header */}
        <div className="bg-hero-gradient py-12">
          <div className="container-salon text-center">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-salon-secondary px-3 py-1 rounded-full bg-salon-secondary/10 mb-3">
              Book Online
            </span>
            <h1 className="font-display text-white text-4xl font-bold">Book Your Appointment</h1>
            <p className="text-white/60 font-body mt-2">Complete the steps below to secure your slot</p>
          </div>
        </div>

        <div className="container-salon py-10">
          {/* Step indicator */}
          <StepIndicator steps={STEPS} current={booking.step} />

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main content */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-3xl shadow-salon-sm border border-salon-cream-dark p-6 md:p-8">
                <StepContent />
              </div>
            </div>

            {/* Summary sidebar */}
            <div className="order-first lg:order-last">
              <BookingSummaryBar />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
